import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS }    from '@angular/common/http';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes , RouterModule} from '@angular/router';
import { QuestionFlowComponent } from './question-flow/question-flow.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { YesNoComponent } from './directives/yes-no/yes-no.component';
import { TextInputComponent } from './directives/text-input/text-input.component';
import { DemographicsComponent } from './demographics/demographics.component';
import { PackageManagerComponent } from './package-manager/package-manager.component';
import { DatepickComponent } from './directives/datepick/datepick.component';
import { DropDownComponent } from './directives/drop-down/drop-down.component';
import { FinalScreenComponent } from './final-screen/final-screen.component';
import { SearchBuilderComponent } from './directives/search-builder/search-builder.component';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { UsersComponent } from './users/users.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { PaymentComponent } from './payment/payment.component';
import { ScreeningsComponent } from './screenings/screenings.component';
import { PackageCreateComponent } from './package-create/package-create.component';
import { PackageListComponent } from './package-list/package-list.component';
import { ScreeningInviteComponent } from './screening-invite/screening-invite.component';
import { AddHttpHeaderInterceptor } from './models/headerInterceptor';
import { FinalScreenAppPayComponent } from './final-screen-app-pay/final-screen-app-pay.component';
import { ApplicantReviewBaseComponent } from './applicant-review-base/applicant-review-base.component';

import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LoadingComponent } from './directives/loading/loading.component';
import { ApplicantReviewWaitingComponent } from './applicant-review-waiting/applicant-review-waiting.component';
import { PhonePipe } from './pipes/phone.pipe';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ApplicantFlowPasswordSetComponent } from './applicant-flow-password-set/applicant-flow-password-set.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { ReportComponent } from './report/report.component';
import { SsnPipe } from './pipes/ssn.pipe';
import { ApplicantReviewReportComponent } from './applicant-review-report/applicant-review-report.component';
import { ApplicantFlowUsernameSetComponent } from './applicant-flow-username-set/applicant-flow-username-set.component';
import { DobPipe } from './pipes/dob.pipe';
import { InvoiceComponent } from './invoice/invoice.component';
import { AalComponent } from './aal/aal.component';
import { TradeLinesComponent } from './trade-lines/trade-lines.component';
import { TradeLineCardComponent } from './trade-line-card/trade-line-card.component';
import { IncomeVerCardComponent } from './income-ver-card/income-ver-card.component';
import { IncomeOverviewComponent } from './income-overview/income-overview.component';
import { IncomeSourceListComponent } from './income-source-list/income-source-list.component';
import { IncomeVerBankCardComponent } from './income-ver-bank-card/income-ver-bank-card.component';
import { IncomeVerPaystubCardComponent } from './income-ver-paystub-card/income-ver-paystub-card.component';
import { IncomeVerWorkNumbaCardComponent } from './income-ver-work-numba-card/income-ver-work-numba-card.component';
import { IncomeVerW2CardComponent } from './income-ver-w2-card/income-ver-w2-card.component';
import { IncomeVer1099CardComponent } from './income-ver-1099-card/income-ver-1099-card.component';
import { IncomeDraftCardComponent } from './income-draft-card/income-draft-card.component';


const routes: Routes = [
  { path: 'screen/:type/:token', component: LandingPageComponent },
  { path: 'demographics', component: DemographicsComponent },
  { path: 'final', component: FinalScreenComponent },
  // { path: 'review', component: ApplicantReviewBaseComponent },
  // { path: 'review-report', component: ApplicantReviewReportComponent },
  { path: 'final/:token', component: FinalScreenAppPayComponent },
  { path: 'pw-set', component: ApplicantFlowPasswordSetComponent },
  { path: 'un-set', component: ApplicantFlowUsernameSetComponent },
  // { path: 'address', component: AddressInfoComponent },
  // { path: 'employment', component: EmploymentInfoComponent },
  // { path: 'packages/create/:client', component: PackageManagerComponent },
  // { path: 'packages/list/:client', component: PackageListComponent },
  // { path: 'screen', component: QuestionFlowComponent },
  // { path: 'screenings/list/:client', component: ScreeningsComponent },
  // { path: 'screenings/create/:client', component: ScreeningInviteComponent },
  { path: 'auth', component: LoginComponent },
  // { path: 'auth/:redirect', component: LoginComponent },
  // { path: 'pass/change', component: PasswordChangeComponent },
  // { path: 'users/list/:client', component: UsersComponent },
  { path: 'user/create/:client', component: CreateUserComponent },
  { path: 'report/:token', component: ReportComponent },
  { path: 'invoice/:token', component: InvoiceComponent },
  { path: 'aal/:token', component: AalComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    QuestionFlowComponent,
    LandingPageComponent,
    YesNoComponent,
    TextInputComponent,
    DemographicsComponent,
    PackageManagerComponent,
    DatepickComponent,
    DropDownComponent,
    FinalScreenComponent,
    SearchBuilderComponent,
    LoginComponent,
    PasswordResetComponent,
    PasswordChangeComponent,
    UsersComponent,
    CreateUserComponent,
    PaymentComponent,
    ScreeningsComponent,
    PackageCreateComponent,
    PackageListComponent,
    ScreeningInviteComponent,
    FinalScreenAppPayComponent,
    ApplicantReviewBaseComponent,
    LoadingComponent,
    ApplicantReviewWaitingComponent,
    PhonePipe,
    ApplicantFlowPasswordSetComponent,
    NumbersOnlyDirective,
    ReportComponent,
    SsnPipe,
    ApplicantReviewReportComponent,
    ApplicantFlowUsernameSetComponent,
    DobPipe,
    InvoiceComponent,
    AalComponent,
    TradeLinesComponent,
    TradeLineCardComponent,
    IncomeVerCardComponent,
    IncomeOverviewComponent,
    IncomeSourceListComponent,
    IncomeVerBankCardComponent,
    IncomeVerPaystubCardComponent,
    IncomeVerWorkNumbaCardComponent,
    IncomeVerW2CardComponent,
    IncomeVer1099CardComponent,
    IncomeDraftCardComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    BrowserAnimationsModule, // required animations module
    MatProgressSpinnerModule, 
    MatRadioModule, 
    MatSliderModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 1000000,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      closeButton : true
    }) // ToastrModule added
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass : AddHttpHeaderInterceptor,
    multi: true
  }, DatePipe, PhonePipe, CookieService, SsnPipe, DobPipe],
  bootstrap: [AppComponent]
})
export class ScreeningModule { }
